import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import Filter from "views/reports/taxPaymentsReport/filter"; // Importing Filter component
import Table from "views/reports/taxPaymentsReport/table"; // Importing Table component
import {devConfig} from "../config/config"; // Importing development configuration

/**
 * Class representing the tax payments report view.
 * @extends JetView
 */
export default class taxPaymentsReport extends JetView {
    /**
     * Configures the UI components of the tax payments report.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: "toolbar", id: "toolbar",
            css: "highlighted_header header6", // CSS classes for styling
            paddingX: 5, paddingY: 5, height: 40,
            cols: [
                { 
                    view: "select", options: ["10", "20", "50", "100"], width: 70, 
                    on: {
                        onChange: function() {
                            // Update pager size and refresh datatable on selection change
                            $$("datatable").getPager().config.size = this.getValue() * 1;
                            $$("datatable").refresh();
                        }
                    }
                },
                {
                    view: "pager", id: "pagerA",
                    template: "{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}",
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch() // Default data fetch size from config
                },
                {
                    view: "richselect", name: "Export", id: "Export", width: 120,
                    placeholder: _("Exportar"), // Placeholder for export selection
                    options: [
                        { id: "1", value: "Excel" }, // Option for Excel export
                        { id: "2", value: "PDF" } // Option for PDF export
                    ],
                    on: {
                        "onChange": function(value) {
                            // Handle export functionality based on selected value
                            if (value == 1) {
                                var table = $$("datatable");
                                // Remove format for columns that have exportType
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format;
                                    }
                                }
                                // Trigger export data event for Excel
                                this.app.callEvent("export:data", [{
                                    NameReport: ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Reporte de Afiliados"),
                                    TypeReport: "Excel"
                                }]);
                                // Export to Excel
                                webix.toExcel(table, {
                                    filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", { hour12: true }).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Reporte de Afiliados"),
                                    ignore: { "Action": true, "detailTittle": true, "ActionTittle": true }
                                });
                            } else {
                                if (value == 2) {
                                    // Trigger export data event for PDF
                                    this.app.callEvent("export:data", [{
                                        NameReport: ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Reporte de Afiliados"),
                                        TypeReport: "PDF"
                                    }]);
                                    // Export to PDF
                                    webix.toPDF($$("datatable"), {
                                        filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", { hour12: true }).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Reporte de Afiliados"),
                                        autowidth: true,
                                        ignore: { "Action": true, "detailTittle": true, "ActionTittle": true }
                                    });
                                }
                            }
                            $$("Export").setValue(""); // Reset export selection
                        }.bind(this)
                    }
                }
            ]
        };

        // Left panel configuration
        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: "toolbar", css: theme,
                    elements: [
                        { view: "label", align: "center", label: _("Impuestos sobre ganancias pagadas - Doradobet Guatemala") },
                        {
                            type: "wide", css: "close-bottom", id: "button-search",
                            cols: [
                                {
                                    view: "icon", icon: "wxi-search", bottom: 20, right: 35, width: 30, height: 30,
                                    click: () => {
                                        $$("filterPopup").show(); // Show filter popup
                                    }
                                }
                            ]
                        },
                        {
                            type: "wide", css: "close-bottom",
                            cols: [
                                {
                                    view: "icon", icon: "wxi-close", bottom: 20, right: 35, width: 30, height: 29,
                                    click: () => this.show("/top/dashboard") // Navigate to dashboard on close
                                }
                            ]
                        },
                    ]
                },
                Filter, // Include Filter component
                Table, // Include Table component
                toolbar // Include toolbar
            ]
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            type: "wide", responsive: true, css: "out", cols: [
                left // Return the left panel configuration
            ]
        };
    }

    /**
     * Initializes the view after it has been rendered.
     */
    init() {
        webix.ready(function () {
            // Adjust UI based on screen size
            if (screen.width < 500 || screen.height < 500) {
                var childs = $$("toolbar").getChildViews();
                $$("toolbar").removeView(childs[2]); // Remove close button for small screens
                $$("pagerA").define("group", 1); // Group pager for small screens
            };
            if (screen.width > 500 && screen.height > 500) {
                $$("button-search").hide(); // Hide search button for larger screens
            }
        });
    }
}

// FILE DOCUMENTED
